import { Locales } from './models/locales.model'
import { PromoCccModel } from './models/promoCcc.model'
import { createClient } from 'contentful'

const client = createClient({
  space: process.env.CONTENTFUL_SPACE_ID,
  accessToken: process.env.CONTENTFUL_DELIVERY_TOKEN,
  environment: process.env.CONTENTFUL_ENVIRONMENT,
})

export const fetcher = async () => {
  const locale: Locales = process.env.LANGUAGE
  const entryItems = await client.getEntries<PromoCccModel>({
    content_type: 'promoCcClinics',
    locale,
  })

  const entries = entryItems.items.map((entry) => {
    const { fields } = entry

    return fields
      ? {
          meta: fields.metaData?.fields,
          header: {
            logo: fields.logo?.fields,
            languageUrl: fields.languageUrl,
            phone: fields.phone,
            email: fields.email,
            locale,
          },
          content: {
            notification: fields.notification,
            sectionTextImage: {
              text: fields.sectionTextImageText,
              image: fields.sectionTextImageImage?.fields,
            },
            ctaButton: fields.ctaButton,
            ctaButtonSecondary: fields.ctaButtonSecondary,
            sectionReason: {
              title: fields.reasonTitle,
              cards: fields.reasonCards,
            },
            symptoms: fields.symptoms,
            sectionTestimonials: {
              text: fields.testimonials,
              image: {
                url: fields.testimonialsBackgroundImage?.fields?.file?.url,
                alt: fields.testimonialsBackgroundImage?.fields?.title,
              },
            },
            sectionImageText: {
              text: fields.sectionImageTextText,
              image: fields.sectionImageTextImage?.fields,
            },
          },
          footer: {
            copyright: fields.copyright,
            terms: fields.terms,
            privacy: fields.privacy,
          },
        }
      : {}
  })

  return { entry: entries[0] }
}
